import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Controller } from "react-hook-form";
import RightToLeftLayout from "../RightToLeft";

const RadioField = ({
  name,
  control,
  required = false,
  fullWidth = true,
  label = "",
  errorObject,
  className = "",
  options,
  size = "small",
  theme = 1,
  ...rest
}) => {
  return (
    <RightToLeftLayout>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl size={size} required={required} fullWidth={fullWidth} error={!!error}>
            <FormLabel
              sx={{
                "& .MuiFormLabel-asterisk": {
                  color: rest?.disabled ? "gray" : "red",
                },
              }}
            >
              {label}
            </FormLabel>
            <RadioGroup
              value={field.value ?? ""}
              onChange={field.onChange}
              name={field.name}
              {...rest}
              label={label}
            >
              {options?.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option.value}
                  control={
                    <Radio
                      sx={
                        theme === 2 && {
                          color: "var(--detail-application-radio-button)",
                          "&.Mui-checked": {
                            color: "var(--detail-application-radio-button)",
                          },
                        }
                      }
                    />
                  }
                  label={option.label}
                  style={{ direction: "rtl" }}
                />
              ))}
            </RadioGroup>
            {(error?.message || errorObject?.message) && (
              <FormHelperText>{error?.message || errorObject?.message}</FormHelperText>
            )}
          </FormControl>
        )}
      />
    </RightToLeftLayout>
  );
};

export default RadioField;
